import { useRouter } from "next/router"
import useStore from "components/ui/Context"
import { getAccessToken } from "lib/Cookies"
import { useEffect, useRef, useState } from "react"
import LoginAlert from "components/ModalLogin/LoginAlert"
import DisplayTypeScreenBlock from "utils/DisplayTypeScreenBlock"
import CardHorizontal from "components/TypeCard/CardHorizontal"
import CardVertical from "components/TypeCard/CardVertical"
import { Modal } from "components/ui"

export default function App(props) {
  let display_type = props.display_type
  let block_type = props.block_type
  const router = useRouter()
  const { toggleModalLogin, userInfo, signKey } = useStore()
  const { id, type, is_protected } = props
  const isMonter = useRef(false)
  const [isModal, setIsModal] = useState(false)

  function onClick(e) {
    if (is_protected && !getAccessToken()) {
      isMonter.current = true
      setIsModal(true)
      // toggleModalLogin()
      e.preventDefault()
      return false
    }
  }

  function onClose() {
    setIsModal(false)
  }

  function onNext() {
    toggleModalLogin()
    setIsModal(false)
  }

  useEffect(() => {
    if (isMonter.current && userInfo?.fullname) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [userInfo])

  useEffect(() => {
    if (isMonter.current && signKey) {
      router.push(`/video?id=${id}&type=${type}`)
    }
  }, [signKey])

  return (
    <>
      <div onClick={onClick}>
        {display_type === DisplayTypeScreenBlock.HORIZONTAL || block_type === 6 ? (
          <CardHorizontal {...props} nextLink={`/video?id=${id}&type=${type}`} customGrid={props.customGrid} />
        ) : (
          <CardVertical {...props} nextLink={`/video?id=${id}&type=${type}`} />
        )}
      </div>
      <Modal
        isOpen={isModal}
        onCancel={() => {
          setIsModal(false)
        }}
        showIcon={false}
      >
        <LoginAlert
          onCancel={() => {
            setIsModal(false)
          }}
          onNext={onNext}
        />
      </Modal>
    </>
  )
}
